var _line, _line2, _line3, _circle, _circle2, _circle3, _circle4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 172,
    viewBox: "0 0 218 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 92.934,
    y1: 95.4741,
    x2: 66.9887,
    y2: 143.97,
    stroke: "#00AD5F"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 75.7156,
    y1: 48.2665,
    x2: 19.099,
    y2: 24.7812,
    stroke: "#FF5619"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 207.432,
    y1: 8.47424,
    x2: 140.207,
    y2: 45.0928,
    stroke: "#FFC400"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.475,
    cy: 63.494,
    r: 39.5,
    transform: "rotate(118.147 109.475 63.494)",
    fill: "#00AD5F",
    stroke: "#00AD5F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.7731,
    cy: 150.787,
    r: 14.5,
    transform: "rotate(118.147 62.7731 150.787)",
    fill: "#00AD5F",
    stroke: "#00AD5F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.78,
    cy: 7.68675,
    r: 4.5,
    transform: "rotate(118.147 210.78 7.68675)",
    fill: "#FFC400",
    stroke: "#FFC400"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7517,
    cy: 24.436,
    r: 10,
    transform: "rotate(121.737 14.7517 24.436)",
    fill: "#FF5619"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2346_13989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 43.207C98.083 43.207 89.208 52.082 89.208 62.9987C89.208 73.9154 98.083 82.7904 109 82.7904C119.916 82.7904 128.791 73.9154 128.791 62.9987C128.791 52.082 119.916 43.207 109 43.207ZM109 81.1237C98.9997 81.1237 90.8747 72.9987 90.8747 62.9987C90.8747 52.9987 98.9997 44.8737 109 44.8737C119 44.8737 127.125 52.9987 127.125 62.9987C127.125 72.9987 119 81.1237 109 81.1237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25 61.6655L105.75 54.4989C104.708 53.8322 103.333 54.5822 103.333 55.8322V70.2072C103.333 71.4572 104.708 72.2072 105.75 71.5405L117.25 64.3739C118.25 63.7072 118.25 62.2905 117.25 61.6655Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2346_13989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(89.001 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconGroup);
export default __webpack_public_path__ + "static/media/play-icon-group.1346480a76f9f9892ab81e24b7ab85e5.svg";
export { ForwardRef as ReactComponent };